module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img246-763d081d088be959de9fc35420ce69e5.jpg";